export const FONT_ONEST = "'Onest', 'Nunito', sans-serif";

export const EMISSION_LOADING_COLORS = {
  primary: '#3D0E6B',
  textMobile: '#2A0B4F',
  pending: '#9A94A6',
  pendingMobile: '#868E96',
  tokenBg: '#F2EEFB',
  spinnerTrack: '#CBBFE6',
  progressTrack: '#E7E4EE',
  sponsoredSlotBg: '#EDE6F6',
  sponsoredChipBg: 'rgba(255, 255, 255, 0.94)',
  sponsoredChipText: '#5B2E9D',
} as const;

export const EMISSION_LOADING_CARD_SHADOW = {
  base: '0px 12px 15px rgba(41, 13, 77, 0.14)',
  md: '0px 14px 18px rgba(41, 13, 77, 0.14)',
};

export const MAX_NON_EMITTED_BAR_VALUE = 90;
export const EMITTED_BAR_VALUE = 100;
export const PROGRESS_BAR_TOTAL_STEPS = 12;
export const PROGRESS_BAR_STEP_INTERVAL_MS = 500;

// Os passos são simulados pelo progresso da barra: o envio só conclui quando a receita é emitida.
export const DOCUMENTS_CREATED_PROGRESS = 30;
export const DOCUMENTS_SIGNED_PROGRESS = 60;
